import { render, staticRenderFns } from "./Imgix.vue?vue&type=template&id=08328761"
import script from "./Imgix.vue?vue&type=script&lang=js"
export * from "./Imgix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports